
import { images } from '../img';

const templates = {
    'ally-accessibility-score-indicator': require('./ally-accessibility-score-indicator.handlebars'),
    'ally-accessible-versions-iframe': require('./ally-accessible-versions-iframe.handlebars'),
    'ally-image-seizure-guard': require('./ally-image-seizure-guard.handlebars'),
    'ally-instructor-feedback-iframe': require('./ally-instructor-feedback-iframe.handlebars')
};

export function apply(templateName, templateParams) {
    templateParams = templateParams || {};
    templateParams.images = templateParams.images || images;
    return templates[templateName](templateParams);
}
